// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const LateFormSingle = () => {
//   // Extracting lformId using regular expressions
//   const location = useLocation();
//   // const lformId = location.pathname.match(/\/class\/(\d+)/);
//   const lformId = location.pathname.match(/\/late-form\/(\d+)/)?.[1];

//   const [lform, setlform] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchClass = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/student/lform/${lformId}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch class');
//       // }
//       const data = await response.json();
//       setlform(data);
//       localStorage.setItem("lformData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (lformId) {
//       fetchClass();
//     }
//   }, [lformId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Late Form Details</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{lform?.data.date}</h1>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Id: </span>
//                                             <span className="itemValue">{lform?.data.id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{lform?.data.center_id}</span>
//                                         </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">
//                       Teacher who mark attendance:{" "}
//                     </span>
//                     <span className="itemValue">{lform?.data.user_names}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Student: </span>
//                     <span className="itemValue">
//                       {lform?.data.student_names}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">late time: </span>
//                     <span className="itemValue">
//                       {lform?.data.time} minutes
//                     </span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Time: </span>
//                                             <span className="itemValue">{lform?.data.time}</span>
//                                         </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Reason for Late: </span>
//                     <span className="itemValue">{lform?.data.reason}</span>
//                   </div>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{lform?.data.status}</span>
//                                         </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="class Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default LateFormSingle;

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const LateFormSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lformId = location.pathname.match(/\/late-form\/(\d+)/)?.[1];
  const [lform, setLform] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchLateForm = async () => {
    try {
      const response = await fetch(`${serverUrl}/student/lform/${lformId}`);
      const data = await response.json();
      setLform(data);
      localStorage.setItem("lformData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (lformId) {
      fetchLateForm();
    }
  }, [lformId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Late Form Details</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Late Form Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Student Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Student Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {lform?.data.student_names}
                      </h1>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        {lform?.data.date && (
                          <div className="bg-gray-50 rounded-lg p-3">
                            <span className="text-gray-500 block">Date:</span>
                            <span className="font-medium">
                              {lform.data.date}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Late Details */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Late Information
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Left Column */}
                    <div className="space-y-4">
                      {lform?.data.time && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Late Duration
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {lform.data.time} minutes
                          </p>
                        </div>
                      )}

                      {lform?.data.user_names && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Marked By
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {lform.data.user_names}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Right Column */}
                    <div className="space-y-4">
                      {lform?.data.reason && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Reason for Late
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {lform.data.reason}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LateFormSingle;
